import React from "react";
import {DashboardContainer} from '../../components/containers/DashboardContainer';

export function DashboardPage() {
  return <DashboardContainer />;
}
